// extracted by mini-css-extract-plugin
export default {"card":"T6-z"};